// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Home_home__SnnHd .Home_hero-section-intro__LBChW {
  width: 100%;
}
.Home_home__SnnHd .Home_divider__NstUY {
  width: 50vw;
  height: 3px;
  background-color: var(--accent-color);
}
.Home_home__SnnHd .Home_divider__container__f6J8z {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  background: var(--background-color-1, #f3f7ff);
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/Home/Home.module.scss"],"names":[],"mappings":"AACE;EACE,WAAA;AAAJ;AAGE;EACE,WAAA;EACA,WAAA;EACA,qCAAA;AADJ;AAGI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,8CAAA;AADN","sourcesContent":[".home {\n  .hero-section-intro {\n    width: 100%;\n  }\n\n  .divider {\n    width: 50vw;\n    height: 3px;\n    background-color: var(--accent-color);\n\n    &__container {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      align-self: stretch;\n      background: var(--background-color-1, #f3f7ff);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"home": `Home_home__SnnHd`,
	"hero-section-intro": `Home_hero-section-intro__LBChW`,
	"divider": `Home_divider__NstUY`,
	"divider__container": `Home_divider__container__f6J8z`
};
export default ___CSS_LOADER_EXPORT___;
